// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"4701":"svg-icons","8177":"remix-icons","9222":"blueprint-icons"}[chunkId] || chunkId) + "." + {"2359":"778516b0","2570":"9d010338","4701":"d88bfe91","4749":"3db36f74","6994":"d08a27f1","7750":"e0af4816","8177":"ee68420e","9222":"c4499702"}[chunkId] + ".chunk.js";
};